<script>
import service from '@/service';
import * as Ladda from 'ladda';
import _ from 'lodash';
const EXCEL_PH_TEXT = 'Izberi ali povleci Excel datoteko za uvoz ...';

export default {
	methods: {
		showModal: function () {
			this.$refs.modal.show();
		},
		modal_okClick: function (evt) {
			evt.preventDefault();
			this.showError(null);
			let loader = Ladda.create(this.$refs.aOk);
			loader.start();
			if (this.show_step_two) {
				service.povracilaSave(this.import_table.items)
					.then(response => {
						loader.stop();
						if (response.processed) {
							// next
							this.clearForm();
							this.$refs.modal.hide();
							this.$emit('povracilaPotrjena-success');
						} else {
							this.showError('Povračil ni mogoče shraniti!');
						}
					})
					.catch(error => {
						loader.stop();
						this.showError('Napaka pri shranjevanju povračil!');
						if (error) {
							console.log(error);
						}
					});
			} else {
				service.povracilaUpload(this.tip_povracila, this.import_file)
					.then(response => {
						loader.stop();
						if (response.items && response.items.length > 0) {
							// next
							this.import_table.items = response.items;
							this.show_step_two = true;
						} else {
							this.showError('Povračil ni mogoče uvoziti!');
						}
					})
					.catch(error => {
						loader.stop();
						this.showError('Napaka pri uvozu povračil!');
						if (error) {
							console.log(error);
						}
					});
			}
		},
		modal_cancelClick: function (evt) {
			evt.preventDefault();
			this.$refs.modal.hide();
			setTimeout(() => {
				this.clearForm();
			}, 300);
		},
		showError: function (message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		clearForm: function () {
			this.show_step_two = false;
			this.tip_povracila = 'excel';
			this.import_file = null;
			this.message = {
				type: null,
				text: null
			};
		},
		vozilaSelect_load: _.debounce((loading, search, vm) => {
			loading(true);
			service.searchVozila(search)
				.then(vozila => {
					loading(false);
					vm.ogrodja_options = vozila;
				})
				.catch(error => {
					loading(false);
					if (error) {
						console.log(error);
					}
				});
		}, 500),
		voziloSelect_change: function (value, index) {
			this.import_table.items[index].id_vozila = value.id;
			this.import_table.items[index].chassis = value.ogrodje;
		},
		vozilaSelect_search: function (search, loading) {
			if (search && search !== '') {
				this.vozilaSelect_load(loading, search, this);
			}
		},
		toggleSelectAll: function () {
			for (let priliv of this.import_table.items) {
				priliv.selected = !this.selectAll;
			}
		}
	},
	watch: {
		tip_povracila: function () {
			this.import_file = null;
			this.showError(null);
		}
	},
	data: function () {
		return {
			show_step_two: false,
			tip_povracila: 'excel',
			import_file: null,
			import_table: {
				items: [],
				fields: [
					{ key: 'selected', sortable: false, class: 'tdPovraciloSelect' },
					{ key: 'creditnotedate', label: 'Datum', sortable: false, class: 'tdPovraciloDatum' },
					{ key: 'chassis', label: 'Ogrodje', sortable: false, class: 'tdPovraciloOgrodje' },
					{ key: 'amount', label: 'Znesek', sortable: false, class: 'tdPovraciloZnesek' }
				]
			},
			ogrodja_options: [],
			message: {
				type: null,
				text: null
			},
			MESSAGE_TYPE_ERROR: 'ERROR',
			selectAll: true
		}
	},
	computed: {
		upload_placeholder () {
			return EXCEL_PH_TEXT;
		},
		upload_accept () {
			return '.xls';
		},
		ok_text () {
			if (this.show_step_two) {
				return 'Potrdi';
			}
			return 'Naprej';
		},
		modal_size () {
			if (this.show_step_two) {
				return 'lg';
			}
			return 'lg';
		},
		modal_body_class () {
			if (this.show_step_two) {
				return 'no_padding';
			}
			return '';
		},
		message_class () {
			if (this.show_step_two) {
				return 'error_message_b';
			}
			return 'error_message';
		}
	},
	created () {
	}
}
</script>
<template>
	<b-modal ref="modal" title="Uvoz povračil" class="modal-primary" :body-class="modal_body_class" :size="modal_size">
		<div v-if="!show_step_two">
			<b-row>
				<b-col>
					<b-form-group>
						<b-form-radio-group v-model="tip_povracila">
							<b-form-radio value="excel">Excel (Excel)</b-form-radio>
						</b-form-radio-group>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-file v-if="tip_povracila == 'excel'"
						v-model="import_file"
						:placeholder="upload_placeholder"
						drop-placeholder="Povleci datoteko za uvoz ..."
						:accept="upload_accept"></b-form-file>
				</b-col>
			</b-row>
		</div>
		<div v-else>
			<b-table
				ref="dataTable"
				responsive="sm"
				show-empty
				hover
				empty-text="Ni vnosov"
				table-class="no_padding"
				:items="import_table.items"
				:fields="import_table.fields">
				<template slot="HEAD_selected">
					 <b-form-checkbox v-model="selectAll" @change="toggleSelectAll"></b-form-checkbox>
				</template>
				<template slot="selected" slot-scope="data">
					 <b-form-checkbox v-model="data.item.selected"></b-form-checkbox>
				</template>
				<template slot="chassis" slot-scope="data">
					<div v-if="data.item.id_vozila == null" class="noVIN"> {{ data.item.chassis }} </div>
					<div v-else> {{ data.item.chassis }} </div>
				</template>
				<template slot="amount" slot-scope="data">
					<span> {{ data.item.amount | hr_money }}</span>
				</template>
				<template slot="creditnotedate" slot-scope="data">
					<div> {{ data.item.creditnotedate | hr_date }} </div>
				</template>
			</b-table>
		</div>
		<b-alert :class="message_class" :variant="message.type && message.type === MESSAGE_TYPE_ERROR ? 'danger' : 'primary'" :show="message.text && message.text !== ''">{{ message.text }}</b-alert>
		<template slot="modal-footer">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="start">
						<b-button v-if="false" variant="warning" @click.stop="click_showPlacila($event.target)">Plačilo</b-button>
					</b-col>
					<b-col align-self="end" class="ma_pos">
						<b-button variant="secondary" @click="modal_cancelClick($event)">Prekliči</b-button>
						<b-button ref="aOk" variant="primary" data-style="zoom-in" @click.stop="modal_okClick($event)">
							<span class="ladda-label">{{ ok_text }}</span>
						</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
	</b-modal>
</template>
<style scoped>
@import '../../../node_modules/ladda/dist/ladda-themeless.min.css';

.ma_pos {
	text-align: end;
}
.noVIN {
    color: red;
}
.error_message {
	margin-top: 1rem;
	margin-bottom: 0;
}
.error_message_b {
	margin: 1rem;
}
</style>
<style>
.no_padding {
	padding: 0;
	margin: 0;
}
.tdPovraciloSelect {
	width: 50px;
}
.tdPovraciloDatum {
	width: 110px;
}
.tdPovraciloOgrodje {
	width: 250px;
}
.tdPovraciloZnesek {
	width: 110px;
	text-align: right;
}
.custom-file-input ~ .custom-file-label::after {
	content: 'Izberi';
}
</style>


// WEBPACK FOOTER //
// src/components/Modals/UvoziPovracilaModal.vue